import { render, staticRenderFns } from "./DeliveryProcedureList.vue?vue&type=template&id=19f463d4&scoped=true&"
import script from "./DeliveryProcedureList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryProcedureList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f463d4",
  null
  
)

export default component.exports